import React from "react"
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react"
import { TriangleDownIcon } from "@chakra-ui/icons"
import merge from "lodash/merge"
import uniqueId from "lodash/uniqueId"

const defaultStyles = {
  "menu-button": {
    height: "28px",
    width: "auto",
    fontSize: "16px",
    lineHeight: "175%",
    letterSpacing: "0.15px",
    color: "#041424",
    fontWeight: "400",
    px: 0,
    bg: "transparent",
  },
  "menu-list": {
    padding: "8px 16px",
    width: "auto",
    height: "124px",
    bg: "background",
    boxShadow:
      "0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 3px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
  },
  "menu-item": {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "normal",
    fontStyle: "normal",
    letterSpacing: "0.15px",
    width: "auto",
    height: "36px",
    "&:hover,&:focus": {
      bg: "transparent",
    },
  },
}

const DropdownMenu = ({ title, children, styles, autoSelect }) => {
  const _styles = merge({}, defaultStyles, styles)
  return (
    <Menu autoSelect={autoSelect}>
      <MenuButton
        as={Button}
        rightIcon={
          <TriangleDownIcon
            color="rgba(0, 0, 0, 0.54)"
            sx={{ fontSize: "10px" }}
          />
        }
        sx={_styles["menu-button"]}
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _expanded={{ bg: "transparent" }}
      >
        {title}
      </MenuButton>
      <MenuList sx={_styles["menu-list"]}>
        {React.Children.map(children, child => (
          <MenuItem key={uniqueId("menu-item")} sx={_styles["menu-item"]}>
            {child}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}

DropdownMenu.defaultProps = {
  styles: {},
  autoSelect: true,
}

export default DropdownMenu
